class IClass {
    constructor() { }

    Init():Promise<void> {
        return Promise.resolve();
    }
}

export default IClass;